const projectsAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      /* GSAP */

      //H1 BANNER
      let split = SplitText.create(".header h1", { type: "lines" });

      gsap.from(split.lines, {
        rotationX: 50,
        transformOrigin: "50% 50% -160px",
        opacity: 0,
        duration: 0.8,
        ease: "power3",
        stagger: 0.25,
      });

      //PROJECT TITLE
      gsap.utils.toArray(".project h2").forEach((title) => {
        gsap.from(title, {
          y: "50px",
          opacity: 0,
          duration: 0.8,
          ease: "power3",
          stagger: 0.25,
          scrollTrigger: {
            trigger: title,
            start: "top+=100 80%",
            end: "bottom top",
            scrub: false,
            markers: false,
            toggleActions: "play none none reverse",
          },
        });
      });

      /* SWIPER */

      document.querySelectorAll(".project-swiper").forEach((el) => {
        new Swiper(el, {
          direction: "horizontal",
          loop: true,
          spaceBetween: 150,
          //freeMode: true,
          navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: el.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 120,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 50,
            },
          },
        });
      });
    });
  },
};

export default projectsAnim;
